<template>
    <table class="table table-hover table-vcenter table-bordered dataTable" style="width:100%">
        <thead>
            <tr>
                <th>Phrase</th>
                <th>Plural</th>
                <th>Child Phrases</th>
                <th>Actions</th>
            </tr>
        </thead>
        <tbody></tbody>
    </table>
</template>

<script>
export default {
    props: {
        ajaxUrl: {
            type: String,
            required: true,
        },
    },

    mounted() {
        window.jQuery(this.$el).dataTable({
            processing: true,
            serverSide: true,
            ajax: {
                url: this.ajaxUrl,
            },
            order: [0, 'asc'],
            pageLength: 25,
            columns: [
                {
                    data: 'phrase',
                },
                {
                    data: 'plural',
                },
                {
                    data: 'children_count',
                    orderable: false,
                    searchable: false,
                },
                {
                    data: 'actions',
                    orderable: false,
                },
            ],
        });
    },
};
</script>

<style scoped>
    td:last-child  {
        text-align: center;
        width: 15%;
    }
</style>
